




import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { Component } from '@niknevis/vue-modules'
import { InvoiceStatus } from '@/modules/invoice/models/invoice-reource.model'

@Component
export default class InvoiceStatusView extends Vue {
  @Prop({ required: true }) status: InvoiceStatus
  @Prop({ required: true }) statuses!: { [key in InvoiceStatus]: string }
  @Prop({ default: false }) dark: boolean

  get statusColor() {
    switch (this.status) {
      case InvoiceStatus.PAID:
        return 'text-green'
      case InvoiceStatus.UNPAID:
        return this.dark ? 'text-yellow' : 'text-amber-7'
      case InvoiceStatus.CANCELLED:
        return 'text-red'
      default:
        return ''
    }
  }
}
